import {IItemPriceShopSimple} from "@/models/item-price/ItemPriceModelsShop";
import {IItemShopListEntry} from "@/models/item/ItemShopModels";
import {ItemState, ItemType, StockStatus, UnitOfMeasure} from "@/helpers/constants";
import {ICategoryShopSimple} from "@/models/category/CategoryShopModels";
import {ITranslatedValue} from "@/models/translated-value/TranslatedValueModels";
import {IAttachment} from "@/models/attachment/AttachmentModels";
import {IPackagingUnit} from "@/models/packaging-unit/PackagingUnitModels";
import {ICustomerItemShopListEntry} from "@/models/customer-item/CustomerItemShopModels";

export class FakeItemShopListEntry implements IItemShopListEntry {
	hasFrameAssembly: boolean = false;
	frameAssemblyPriceTable: IItemPriceShopSimple[] | null = null;
	itemType: ItemType = ItemType.linkItem;
	remoteUrl: string | null = '';
	isTrimmingCostCharged: boolean = false;
	alternativeItemNumber: string | null = null;
	itemNumberShort: string | null = null;
	applicationRange: string | null = null;
	assemblyGroup: string | null = null;
	avatarAttachmentId: string | null = null;
	baseUnitOfMeasure: UnitOfMeasure = UnitOfMeasure.unitAssortment;
	canOrderSample: boolean = false;
	canonical: string | null = null;
	category: ICategoryShopSimple = {} as ICategoryShopSimple;
	color: ITranslatedValue | null = null;
	connectionType: ITranslatedValue | null = null;
	crossSection: number | null = null;
	deliveryTime: number | null = null;
	density: number | null = null;
	diameterMm: number | null = null;
	fireProtectionStandard: ITranslatedValue | null = null;
	fixture: string | null = null;
	foodStandard: string | null = null;
	galleryAttachments: IAttachment[] = [];
	glassThickness: number | null = null;
	glassThicknessRaw: string | null = null;
	grooveDepth: number | null = null;
	grooveWidth: number | null = null;
	grooveWidthRaw: string | null = null;
	grossWeight: number | null = null;
	hardness: number | null = null;
	hardnessType: ITranslatedValue | null = null;
	height: number | null = null;
	id: string = '';
	innerDiameter: number | null = null;
	isTopSeller: boolean = false;
	isSalesUnitFixed: boolean = false;
	itemNumber: string = '';
	length: number | null = null;
	material: ITranslatedValue | null = null;
	name: ITranslatedValue = {} as ITranslatedValue;
	otherStandard: string | null = null;
	outerDiameter: number | null = null;
	price: IItemPriceShopSimple | null = null;
	prices: IItemPriceShopSimple[] = [];
	properties: ITranslatedValue | null = null;
	rebate: number | null = null;
	rebateRaw: string | null = null;
	rebateSpace: number | null = null;
	rebateSpaceRaw: string | null = null;
	resistance: string | null = null;
	ringDiameter: number | null = null;
	salesUnitOfMeasure: UnitOfMeasure = UnitOfMeasure.unitAssortment;
	salesUnitQuantity: number = 0;
	state: ItemState = ItemState.active;
	stockQuantity: number = 0;
	externalStockStatus: StockStatus = StockStatus.stockHigh;
	stockStatus: StockStatus = StockStatus.stockHigh;
	stockStatusOverride: StockStatus = StockStatus.stockHigh;
	surfaceTreatment: ITranslatedValue | null = null;
	system: string | null = null;
	thread: string | null = null;
	threadLength: number | null = null;
	tolerance: ITranslatedValue | null = null;
	type: ITranslatedValue | null = null;
	width: number | null = null;
	wrenchSize: number | null = null;
	packagingUnit1: IPackagingUnit | null = null;
	packagingUnit2: IPackagingUnit | null = null;
	packagingUnit3: IPackagingUnit | null = null;
	packagingUnit4: IPackagingUnit | null = null;
	customerItem: ICustomerItemShopListEntry | null = null;
}
